export default __webpack_public_path__ + "static/media/Twitch Icon.f9a4c4a8.svg";